'use strict';

import CartActionRequired from './components/CartActionRequired.vue';

export default class {

    constructor() {
        // Register component globaly
        Vue.component('cart-action-required', CartActionRequired);

    }
}